<template>
  <v-dialog v-model="open_dialog" width="800" persistent :hide-overlay="hide_dialog" scrollable>
    <v-card class="rounded-xl overflow-hidden elevation-24">
      <v-toolbar flat color="white" class="px-2 pt-2">
        <v-toolbar-title class="text-h5 font-weight-bold grey--text text--darken-2 d-flex align-center">
          <v-icon color="primary" class="mr-3" large>tune</v-icon>
          Filtros del Reporte
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close(false)" class="grey--text">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-6 pt-2">
        <v-container class="pa-0">
          <!-- Selection Section -->
          <div class="mb-6">
            <label class="text-caption font-weight-bold grey--text text-uppercase mb-2 d-block letter-spacing-1">Entidad
              y Ubicación</label>
            <v-row dense>
              <v-col cols="12">
                <v-autocomplete v-model="filters.business_unit" :items="business_filtered" label="Unidad de Negocio"
                  outlined dense prepend-inner-icon="corporate_fare" color="primary" class="rounded-lg mb-2"
                  @change="get_business_data()" return-object hide-details></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete v-model="filters.location" :items="locations_filtered" label="Ubicación (Opcional)"
                  outlined dense prepend-inner-icon="my_location" color="primary" class="rounded-lg"
                  :disabled="!filters.business_unit || filters.business_unit.id == 0" return-object clearable
                  hide-details></v-autocomplete>
              </v-col>
            </v-row>
          </div>

          <!-- Currency Section -->
          <div class="mb-6 bg-grey lighten-5 pa-4 rounded-xl border-light">
            <div class="d-flex align-center mb-3">
              <label
                class="text-caption font-weight-bold grey--text text-uppercase letter-spacing-1 mr-2">Moneda</label>
              <v-tooltip right max-width="300">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon small color="grey" v-bind="attrs" v-on="on">help_outline</v-icon>
                </template>
                <div class="pa-1">
                  <div class="font-weight-bold mb-1">Opciones de Moneda:</div>
                  <div class="mb-1">• <b>Base:</b> Moneda principal del negocio.</div>
                  <div class="mb-1">• <b>Transacción:</b> Moneda original de la factura.</div>
                  <div>• <b>Convertir:</b> Convierte todo a una moneda específica.</div>
                </div>
              </v-tooltip>
            </div>

            <v-radio-group v-model="filters.currency_type" row hide-details class="mt-0 mb-4"
              :disabled="!filters.business_unit">
              <v-radio label="Base" :value="1"
                @change="filters.currency = currencies.find(c => c.id == currencies[0].default_currency_id)"></v-radio>
              <v-radio label="Transacción" :value="2"></v-radio>
              <v-radio label="Convertir a" :value="3" @change="filters.currency = null"></v-radio>
            </v-radio-group>

            <v-autocomplete v-model="filters.currency" :items="currencies_filtered" label="Seleccione Moneda" outlined
              dense class="rounded-lg" item-text="description" item-value="id" :disabled="filters.currency_type == 1"
              return-object hide-details></v-autocomplete>
          </div>

          <!-- Time Range Section -->
          <div class="mb-6">
            <label class="text-caption font-weight-bold grey--text text-uppercase mb-2 d-block letter-spacing-1">Año y
              Periodo</label>

            <v-row dense>
              <v-col cols="4" v-if="filter_options.show_calendar">
                <v-autocomplete v-model="filters.calendar" :items="calendars" label="Calendario" outlined dense
                  prepend-inner-icon="event_note" item-text="name" item-value="accounting_calendar_id"
                  class="rounded-lg mb-2" :disabled="!filters.business_unit" return-object
                  @change="get_periods_by_calendar" hide-details></v-autocomplete>
              </v-col>

              <v-col cols="12" v-if="!filter_options.show_calendar">
                <v-autocomplete v-model="filters.due_days" :items="due_days" label="Días de Vencimiento" outlined dense
                  color="primary" class="rounded-lg mb-2" return-object hide-details></v-autocomplete>
              </v-col>

              <!-- Period start/end (solo cuando show_date_range) -->
              <!-- <v-col cols="6" v-if="filter_options.show_date_range">
                <v-autocomplete dense hide-details outlined
                  :disabled="!filters.business_unit || !filters.calendar"
                  v-model="filters.period_start"
                  :items="periods_start_filtered"
                  label="Desde el periodo (Opcional)"
                  class="rounded-lg mb-2"
                  color="primary" item-text="name" @change="update_date('start')"
                  item-value="accounting_period_id"
                  prepend-inner-icon="date_range"
                  return-object></v-autocomplete>
              </v-col> -->
              <!-- <v-col cols="6" v-if="filter_options.show_date_range">
                <v-autocomplete dense hide-details outlined
                  :disabled="!filters.business_unit || !filters.calendar"
                  v-model="filters.period_end"
                  :items="periods_end_filtered"
                  label="Hasta el periodo (Opcional)"
                  class="rounded-lg mb-2"
                  color="primary" item-text="name" @change="update_date('end')"
                  item-value="accounting_period_id"
                  return-object></v-autocomplete>
              </v-col> -->

                   <v-col cols="8" v-if="filter_options.show_date_range">
                      <v-autocomplete
                        v-model="filters.current_period"
                        :items="periods"
                        label="Selecciona un periodo"
                        :disabled="!filters.business_unit || !filters.calendar"
                        item-text="name"
                        return-object
                        @change="on_period_change"
                        prepend-inner-icon="mdi-sitemap-outline"
                        item-value="id"
                        outlined dense hide-details
                        class="rounded-lg"
                      >
                        <template v-slot:selection="data">
                          <span v-html="data.item.name"></span>
                        </template>
                        <template v-slot:item="data">
                          <div v-html="data.item.name"></div>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title class="red--text">Selecciona primero un calendario</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                   

              <!-- Desde (show_date_range) / Tipo de Fecha (!show_date_range) -->
              <!-- <v-col cols="6" v-if="filter_options.show_date_range">
                <v-menu v-model="menuStart" :close-on-content-click="false" :nudge-right="10"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field dense outlined v-model="dateFormatDMY" label="Desde"
                      prepend-inner-icon="today" readonly class="rounded-lg"
                      v-bind="attrs" v-on="on" hide-details></v-text-field>
                  </template>
                  <v-date-picker v-model="filters.dateStart" no-title color="primary"
                    @input="(menuStart = false), (filters.period_start = { accounting_period_id: null })"></v-date-picker>
                </v-menu>
              </v-col> -->
              <v-col cols="6" v-if="!filter_options.show_date_range">
                <v-autocomplete v-model="filters.date_type" :items="date_types" label="Tipo de Fecha" outlined dense
                  class="rounded-lg" return-object hide-details></v-autocomplete>
              </v-col>

              <!-- Hasta / Fecha de Corte (siempre visible) -->
              <v-col cols="6" v-if="!filter_options.show_date_range">
                <v-menu v-model="menuEnd" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="date2FormatDMY" label="Hasta" outlined dense readonly
                      class="rounded-lg" prepend-inner-icon="insert_invitation" v-bind="attrs" v-on="on"
                      hide-details></v-text-field>
                  </template>
                  <v-date-picker v-model="filters.dateEnd" no-title color="primary"
                    @input="(menuEnd = false), (filters.period_end = { accounting_period_id: null })"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </div>

          <!-- Entity Type Section -->
          <div v-if="filter_options.show_customer_type || filter_options.show_supplier_type" class="mb-2">
            <label class="text-caption font-weight-bold grey--text text-uppercase mb-2 d-block letter-spacing-1">Filtro
              Específico</label>

            <v-row dense>
              <v-col cols="12">
                <v-autocomplete v-if="filter_options.show_supplier_type" v-model="filters.supplier_type"
                  :items="supplier_types" label="Tipo de Suplidor" outlined dense class="rounded-lg mb-2"
                  item-text="name" item-value="id" @change="filters.entity = null" return-object
                  hide-details></v-autocomplete>

                <v-autocomplete v-if="filter_options.show_customer_type" v-model="filters.customer_type"
                  :items="customer_types" label="Tipo de Cliente" outlined dense class="rounded-lg mb-2"
                  item-text="name" item-value="id" @change="filters.entity = null" return-object
                  hide-details></v-autocomplete>
              </v-col>

              <v-col cols="9">
                <v-text-field :value="filters.entity?.name" label="Entidad Seleccionada" outlined dense readonly
                  class="rounded-lg" hide-details @click:append="filters.entity = null"
                  :append-icon="filters.entity ? 'close' : ''"></v-text-field>
              </v-col>
              <v-col cols="3">
                <searchClients :types_clients="filter_options.entity_type" :buston_style="true"
                  @selected-item="select_entity($event)" @open-dialog="hide_dialog = true"
                  @close-dialog="hide_dialog = false" />
              </v-col>
            </v-row>
          </div>

          <!-- Language Section -->
          <div v-if="filter_options.show_language_type" class="mt-4">
            <v-select v-model="filters.language"
              :items="[{ value: 'es', text: 'Español' }, { value: 'en', text: 'Inglés' }]" label="Idioma del Reporte"
              outlined dense class="rounded-lg" prepend-inner-icon="language" hide-details></v-select>
          </div>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="pa-6">
        <v-btn color="grey underline" text class="rounded-lg text-none font-weight-bold" @click="close(false)">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="success" depressed height="48" class="rounded-lg px-8 text-none font-weight-bold elevation-1"
          @click="close(true)" :disabled="can_filter" :loading="loading">
          Generar Reporte
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from "moment";
import searchClients from "@/components/Income/SearchClientOrSupplier.vue";
export default {
  data: () => ({
    hide_dialog: false,
    filters: {
      business_unit: null,
      location: { catalogue_id: null, id: null },
      currency_type: 1,
      currency: null,
      calendar: null,
      period_start: { accounting_period_id: null },
      period_end: { accounting_period_id: null },
      current_period: null,
      dateStart: moment().startOf("year").format("YYYY-MM-DD"),
      dateEnd: moment().endOf("year").format("YYYY-MM-DD"),
      date_type: null,
      due_days: null,
      customer_type: {},
      supplier_type: {},
      entity: null,
      language: 'es'
    },
    due_days: [{ text: '30 Dias', value: 1, range: [30, 60, 90] }, { text: '15 Dias', value: 2, range: [15, 30, 45] }, { text: '7 Dias', value: 3, range: [7, 14, 21] }],
    currencies: [],
    calendars: [],
    periods: [],
    customer_types: [],
    supplier_types: [],
    menuStart: false,
    menuEnd: false,
    date_types: [{ value: 1, text: 'Contable', en: 'Accountant' }, { value: 2, text: 'Emision', en: 'Issue' }, { value: 3, text: 'Vencimiento', en: 'Expiration' }]
  }),
  name: "HeaderFiltersReports",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    open_dialog: {
      type: Boolean,
      default: false,
    },
    filter_options: {
      type: Object,
      default() {
        return {
          show_calendar: true,
          show_supplier_type: false,
          show_customer_type: false,
          show_date_type: false,
          show_date_range: true,
          show_language_type: false,
          entity_type: 2
        }
      }
    }
  },
  mounted() {
    this.filters.date_type = this.date_types[0];
    this.filters.due_days = this.due_days[0];
    this.initialized();
  },
  computed: {
    dateFormatDMY() {
      return moment(this.filters.dateStart).format("DD/MM/YYYY");
    },
    date2FormatDMY() {
      return moment(this.filters.dateEnd).format("DD/MM/YYYY");
    },
    currencies_filtered() {
      // if(this.filters.currency_type==3){
      //   return this.currencies.filter((element)=>element.id!=this.currencies[0].default_currency_id)
      // }
      if (this.filters.currency_type == 2) {
        let currencies = Object.assign([], this.currencies);
        currencies.unshift({
          default_currency_id: 3,
          value: "1",
          id: 0,
          description: "TODAS",
          code: "ALL"
        })
        this.filters.currency = currencies[0];
        return currencies;
      }
      return this.currencies;
    },
    periods_start_filtered() {
      if (this.filters.period_end.accounting_period_id == null) {
        return this.periods
      }
      return this.periods.filter((element) => element.accounting_period_id <= this.filters.period_end.accounting_period_id);
    },
    periods_end_filtered() {
      return this.periods.filter((element) => element.accounting_period_id >= this.filters.period_start.accounting_period_id);
    },
    locations_filtered() {
      if (this.filters.business_unit == null) {
        return []
      }
      return this.$store.state.auth.locations.filter((element) => element.bus_id == this.filters.business_unit.id);
    },
    business_filtered() {
      let business = this.$store.state.auth.bussines_units;
      // business.unshift(
      //   {
      //       text: "CONSORCIO",
      //       value: 0,
      //       id: 0,
      //       currency_id: 3
      //   } );
      return business;
    },
    calendar_limits() {
      if (this.filters.calendar == null) {
        return {
          min: moment().format("YYYY-01-01"),
          max: moment().format("YYYY-12-31")
        }
      }
      return {
        min: this.filters.calendar.date_from,
        max: this.filters.calendar.date_to
      };
    },
    can_filter() {
      if (this.filters.customer_type.id == -1 && this.filters.entity == null) {
        return true;
      }
      return this.filters.business_unit == null;
    }
  },
  methods: {
    async initialized() {
      if (this.filter_options.show_customer_type) {
        this.customer_types = await this.get_customer_types('customer_types', 'CLIENTE');
        this.filters.customer_type = this.customer_types[0];
      }
      if (this.filter_options.show_supplier_type) {
        this.supplier_types = await this.get_customer_types('supplier_types', 'SUPLIDOR');
        this.filters.supplier_type = this.supplier_types[0];
      }
    },
    get_business_data() {
      this.filters.location = null;
      if (this.filters.business_unit == null) {
        return
      }
      this.get_currencies();
      this.get_calendar();
    },
    async get_currencies() {
      const resultCurrencies = await this.api_Post("accounting/currenciesBusiness",
        {
          business: this.filters.business_unit.id,
          effective_date: moment().format("YYYY-MM-DD"),
        }
      );
      this.currencies = await resultCurrencies.json();
      this.filters.currency = this.currencies.find((element) => element.default_currency_id == element.id)
    },
    async get_customer_types(type, text) {
      const resultCustomer = await this.api_Get("entity/" + type);
      let data = await resultCustomer.json();
      data.unshift({ id: 0, name: 'TODOS' });
      data.push({ id: -1, name: text + ' ESPECIFICO' });
      return data;
    },
    async get_calendar() {
      try {
        const resultCalendar = await this.api_Get("accounting/calendars_by_business_unit/" + this.filters.business_unit.id);
        const dataCalendar = await resultCalendar.json();
        if (resultCalendar.status == 200 && dataCalendar.length > 0) {
          this.calendars = dataCalendar;
          this.filters.calendar = dataCalendar[0];
          await this.get_periods_by_calendar();
        }
      } catch (error) {
        console.error(error.message);
      }
    },
    async get_periods_by_calendar() {
      if (!this.filters.calendar) return;
      try {
        const calendarId = this.filters.calendar.accounting_calendar_id ?? this.filters.calendar;
        const resultPeriods = await this.api_Get("accounting/periods_by_calendar/" + calendarId);
        const dataPeriods = await resultPeriods.json();
        this.periods = dataPeriods.map((element) => {
          const name =
            `<span style="color:blue;">Periodo: ${element.accounting_period_id}</span> - ` +
            moment(element.date_from).format("DD-MMMM-YYYY") + " - " +
            moment(element.date_to).format("DD-MMMM-YYYY");
          return { ...element, name };
        });
        this.filters.current_period = null;
      } catch (error) {
        console.error(error.message);
      }
    },
    update_date(type) {
      if (type == "start" && this.filters.period_start.accounting_period_id != null) {
        this.filters.dateStart = this.filters.period_start.date_from;
      }
      if (type == "end" && this.filters.period_end.accounting_period_id != null) {
        this.filters.dateEnd = this.filters.period_end.date_to;
      }
    },
    on_period_change(period) {
      if (period) {
        this.filters.dateStart = period.date_from;
        this.filters.dateEnd   = period.date_to;
      }
    },
    select_entity(item) {
      this.filters.entity = item;
      if (this.filter_options.show_customer_type) {
        this.filters.customer_type = this.customer_types[this.customer_types.length - 1]
      } else {
        this.filters.supplier_type = this.supplier_types[this.supplier_types.length - 1]
      }
      this.hide_dialog = false;
    },
    close(res) {
      if (this.filters.currency_type == 3 && this.filters.currency == null) {
        this.$toast.warning("Escoja la moneda a la que desea convertir!");
        return
      }
      this.$emit("set_filters", { response: res, filters: this.filters, currencies: this.currencies });
    },
  },
  components: {
    searchClients
  },
};
</script>

<style scoped>
.border-light {
  border: 1px solid #f0f0f0 !important;
}

.letter-spacing-1 {
  letter-spacing: 1px !important;
}

.v-dialog>.v-card {
  overflow: hidden;
}

.bg-grey.lighten-5 {
  background-color: #fafafa !important;
}

.rounded-xl {
  border-radius: 24px !important;
}

.rounded-lg {
  border-radius: 12px !important;
}

/* Custom transitions and hover states */
.v-btn--depressed {
  transition: all 0.2s ease;
}

.v-btn--depressed:hover {
  filter: brightness(0.95);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

/* Scrollbar styling */
.v-card__text::-webkit-scrollbar {
  width: 6px;
}

.v-card__text::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.v-card__text::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

.v-card__text::-webkit-scrollbar-thumb:hover {
  background: #999;
}

.glass-effect {
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.opacity-20 {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.opacity-80 {
  opacity: 0.8;
}
</style>